import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { APP_VERSION, ENVIRONMENT } from 'shared/conf/constants';
import App from './app';
import reportWebVitals from './reportWebVitals';
import 'normalize.css';
import 'shared/styles/main.css';
import 'shared/styles/pages.css';

Sentry.init({
  dsn: 'https://cb1eb1ecdb7a41c4a26406bdcfee7c53@sentry.vpluse.me/17',
  integrations: [new Sentry.BrowserTracing()],
  environment: ENVIRONMENT,
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<h1>Произошла ошибка.</h1>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// eslint-disable-next-line
console.log(`%cAPP_VERSION: ${APP_VERSION}`, 'color: red; background: aqua; font-size: 30px');

reportWebVitals();
